<script setup>
import { API } from '@/services/api/main'
import request from '@/services/utils/request'
import { useAppStore } from '@/store/modules/app'
import { maintainShowVconsole } from '@/services/utils/vconsole'
import { ensureAuthenticated, isAuthenticationPage, openAuthenticationGateway } from '@/services/collaboration-login/bootstrap'
import { authenticationState } from '@/services/collaboration-login/auth-state'
import { getAccessToken, getRefreshToken } from '@/services/utils/auth'
import { readCollaborationLoginQuery } from '@/services/collaboration-login/session'
import { initializeVideoPlaybackTelemetryReporter } from '@/packageLearn/utils/videoPlaybackRemoteReporter'

const appStore = useAppStore()
watch(() => authenticationState.status, status => {
    if (status !== 'ready') return
    const route = readCollaborationLoginQuery(location.href).get('redirect') || location.hash
    if (route.includes('/packageLearn/') || route.includes('/packageMain/pages/learn/')) {
        void fetchUnreadCount()
        void fetchLastViewed()
    }
})

onLaunch(() => {
    console.log('App Launch')
    setSystemInfo()
    initializeVideoPlaybackTelemetryReporter()
})

onShow(async () => {
    console.log('App Show')

    try {
        if (!isAuthenticationPage(location.href)) {
            const generation = authenticationState.generation
            if (!await ensureAuthenticated() && (generation === authenticationState.generation
                || (!getAccessToken() && !getRefreshToken()))) {
                await openAuthenticationGateway()
            }
        }
    } catch {
        // 临时故障保留当前页面和凭据，下一次请求可重新尝试恢复。
        console.warn('登录状态暂时无法恢复')
    }
    maintainShowVconsole()
})

onHide(() => {
    console.log('App Hide')
})

async function fetchUnreadCount() {
    request({ ...API.getCourseNotificationUnread, silent: true })
        .then((data) => {
            appStore.setUnreadCount(data.data || 0)
        })
        .catch((error) => {
            appStore.setUnreadCount(0)
            console.warn('[App] load learn unread count failed', error)
        })
}

async function fetchLastViewed() {
    request({ ...API.getMyLastViewed, silent: true })
        .then((data) => {
            appStore.setLastPlayed(data.data || 0)
            appStore.setShowLastPlayed(!!data.data)
        })
        .catch((error) => {
            appStore.setLastPlayed(0)
            appStore.setShowLastPlayed(false)
            console.warn('[App] load last viewed course failed', error)
        })
}

async function setSystemInfo() {
    const systemInfo = uni.getSystemInfoSync()
    console.log(systemInfo)
    appStore.setSystemInfo(systemInfo)
}

provide('fetchUnreadCount', fetchUnreadCount)
provide('fetchLastViewed', fetchLastViewed)
</script>

<style lang="scss">
@use '@/assets/styles/font.css';
@use '@/assets/styles/index.scss';

scroll-view {
    -webkit-overflow-scrolling: touch;
}

scroll-view ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
}

.uni-scroll-view::-webkit-scrollbar {
    display: none;
}

#__vconsole {
    display: none;
    &.show {
        display: block;
    }
}

/* 禁止页面整体滚动回弹效果 */
// html,
// body {
//     overscroll-behavior: none;
//     touch-action: none;
// }
</style>
